import React = require('react')
import { Route } from 'react-router'
import { Action, loadingAsyncState } from 'widgets-for-react'
import { fetchEventDetails, fetchEvents, GroupedOverviewResult } from '../../backendApi/EventsApi'
import { EventDetailsFrontend } from '../../backendApi/generated'
import { parseParamsFromUrl } from '../../backendApi/utils'
import { previousOrDefault } from '../../utils/asyncState'
import { emptyJumbo, JumboProps } from '../Jumbo/Jumbo'
import { EventDetailsWidget } from './EventDetails/EventDetailsWidget'
import { emptyFilters, EventsOverviewClassNames } from './EventOverview/EventOverviewState'
import { EventOverviewWidget } from './EventOverview/EventOverviewWidget'
import { EventsApplicationState, EventsConfig } from './EventState'

type Updater = (_: Action<EventsApplicationState>) => void

export const EventRoutes = (props: {
  state: EventsApplicationState
  setState: Updater
  config: EventsConfig
  eventsOverviewClassNames: EventsOverviewClassNames
}) => {
  const {
    state,
    setState,
    eventsOverviewClassNames,
    config: { prefix, loadJumbo, Jumbo, renderCustomCmsPage, Blocks }
  } = props

  return [
    <Route
      key="events/overview"
      path={`${prefix}`}
      exact={true}
      render={_ => {
        const s0 = state.eventOverview

        // Upon first load, allow query params to override initial settings
        let events = s0.events
        let filterSettings = s0.filterSettings
        if (s0.events.kind == 'unloaded') {
          const params = parseParamsFromUrl(emptyFilters)
          events = loadingAsyncState<GroupedOverviewResult>(fetchEvents(params))
          filterSettings = { ...params }
        }

        const jumboContent =
          s0.jumboContent.kind == 'unloaded' ? loadingAsyncState<JumboProps>(loadJumbo, emptyJumbo) : s0.jumboContent
        return EventOverviewWidget({
          ...state.eventOverview,
          events,
          filterSettings,
          jumboContent,
          Jumbo,
          eventsOverviewClassNames
        }).run(eventOverview => setState(prevState => ({ ...prevState, eventOverview })))
      }}
    />,
    <Route
      key="events/details"
      path={`${prefix}/:eventId+`}
      render={route => {
        const s0 = state.eventDetails
        const eventId = route.match.params['eventId'] || s0.eventId
        const event =
          eventId == s0.eventId
            ? s0.event
            : loadingAsyncState<EventDetailsFrontend>(fetchEventDetails(eventId), previousOrDefault(s0.event, null))
        return EventDetailsWidget({
          ...state.eventDetails,
          eventId,
          event,
          Jumbo,
          renderCustomCmsPage,
          Blocks,
          eventsOverviewClassNames
        }).run(eventDetails => setState(prevState => ({ ...prevState, eventDetails })))
      }}
    />
  ]
}
